import React, { createRef, useContext, useEffect, useRef, useState } from 'react';
import Link from 'next/link';
import { MapContainer, TileLayer, Popup, CircleMarker, useMapEvent } from 'react-leaflet';
import 'leaflet/dist/leaflet.css'
import 'leaflet-defaulticon-compatibility/dist/leaflet-defaulticon-compatibility.css'
import "leaflet-defaulticon-compatibility";
// import "leaflet-gesture-handling/dist/leaflet-gesture-handling.css";
import { MdKeyboardArrowRight } from 'react-icons/md';
import { fleatoConfig } from '../../fleato-config';
import ReactPlayer from 'react-player';
import { ArtistProfile } from '../../models/user';
import { LatLngExpression, Map as LeafletMap } from 'leaflet';

function Map({ artists, title, height, width }: { artists: ArtistProfile[], title?: string, height?: string, width?: string }) {
    const mapToken = fleatoConfig.mapBox;

    const [instance, setInstance] = useState<LeafletMap>();
    useEffect(() => {
        setTimeout(() => {
            try {
                instance?.invalidateSize();
            } catch (err) {
                console.log("Invalidate size not ready");
            }
        }, 1000)
        const center = artists?.[0]?.locationLatLng?.length > 0 ? artists[0].locationLatLng : [0, 20] as LatLngExpression;
        const zoom = 3;
        instance?.setView(center, zoom);
    }, [instance, artists])
    return (
        <div className='pt-2' style={{ backgroundColor: "#333333", zIndex: 10, }} >
            {title &&
                <h1 className='py-5 text-white text-center m-0 ' style={{ zIndex: 100, }}>{title}</h1>
            }
            <MapContainer zoom={10} scrollWheelZoom={false} style={{ height: height ?? "600px", width: width ?? "100%" }} whenCreated={instance => setInstance(instance)} >
                <TileLayer attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                    url={`https://api.mapbox.com/styles/v1/sparklee/cl0uqo5cc000215mz6ua4b4u9/tiles/256/{z}/{x}/{y}@2x?access_token=${mapToken}`}
                />
                {/* attribute="Map data &copy; <a href=&quot;https://www.openstreetmap.org/&quot;>OpenStreetMap</a> contributors, <a href=&quot;https://creativecommons.org/licenses/by-sa/2.0/&quot;>CC-BY-SA</a>, Imagery &copy; <a href=&quot;https://www.mapbox.com/&quot;>Mapbox</a>" */}
                {artists?.filter(a => a.locationLatLng?.length == 2).map(artist => (
                    <CircleMarker key={artist.id}
                        center={{ lat: artist?.locationLatLng?.[0] ?? 0, lng: artist?.locationLatLng?.[1] ?? 0 }}
                        fillColor="blue"
                        radius={8}
                    >
                        <Popup>
                            <div style={{ backgroundColor: "#e2e2e2", height: 200, width: 250, borderRadius: "5px" }}>
                                <div className='d-flex align-items-center justify-content-center overflow-hidden' >
                                    <Link href={`/m/a/${artist.id}`} passHref>
                                        {artist?.video ?
                                            <ReactPlayer
                                                style={{ margin: "-5px", borderRadius: "5%" }}
                                                url={artist?.video}
                                                loop={true}
                                                controls={true}
                                                muted={true}
                                                playing={true}
                                                width={'100%'}
                                                height={'100%'}
                                            /> :
                                            <img className='cursor-pointer img-fluid' src={artist?.image} alt={" picture of " + artist?.name} />

                                        }

                                    </Link>
                                </div>
                                <div className='white-bg' style={{ height: " 25%", width: " 100%", borderRadius: "0 0 5px 5px " }}>
                                    <div className='d-flex align-items-center justify-content-between mx-2 '>
                                        <p className='bold text-black m-0 my-3'>{artist.storeName ?? artist.name}</p>
                                        <p className='cursor-pointer m-0 my-3'><MdKeyboardArrowRight size={24} /></p>
                                    </div>
                                </div>
                            </div>
                        </Popup>
                    </CircleMarker>
                ))}
            </MapContainer>
        </div >
    )
}

export default Map;


// const map = mapVal("map", {
//     center: [50.36, -4.747],
//     zoom: 3,
//     // gestureHandling: true
// });
